(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu-new"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const megaMenus = document.querySelectorAll('header-menu-new');
  
  megaMenus.forEach(function(megaMenu) {
    const container = megaMenu.querySelector('.mega-menu-new');
    const trigger = megaMenu.querySelector('.mega-menu-new__trigger');
    const content = megaMenu.querySelector('.mega-menu-new__content');
    const toggles = megaMenu.querySelectorAll('.mega-menu-new__main-toggle');
    const activeContent = megaMenu.querySelector('.mega-menu-new__active-content');
    
    // Flag to track if we're in the middle of an animated close
    let isClosing = false;
    let isOpen = false;
    
    // Store initial content on page load for later restoration
    if (activeContent) {
      const initialContent = activeContent.querySelector('.mega-menu-new__initial-content');
      const placeholder = activeContent.querySelector('.mega-menu-new__placeholder');
      
      if (initialContent) {
        activeContent.dataset.originalContent = initialContent.outerHTML;
      } else if (placeholder) {
        activeContent.dataset.originalContent = placeholder.outerHTML;
      }
    }
    
    // Helper function to update menu position
    function updateMenuPosition() {
      if (!isOpen || !content) return;
      
      const header = document.querySelector('.header');
      if (header) {
        const rect = header.getBoundingClientRect();
        content.style.top = rect.bottom + 'px';
      }
    }
    
    // Scroll handler to update position when announcement bar appears/disappears
    let scrollTimeout;
    function handleScroll() {
      if (!isOpen) return;
      
      // Update position on scroll
      updateMenuPosition();
      
      // Debounce for performance
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateMenuPosition, 50);
    }
    
    // Add scroll listener (will be added when menu opens)
    let scrollListenerAdded = false;
    
    // Check if menu was already opened before JS loaded (race condition fix)
    if (container && container.classList.contains('is-open') && content) {
      // Menu is already open, initialize it properly
      isOpen = true;
      trigger.setAttribute('aria-expanded', 'true');
      
      // Set initial position
      updateMenuPosition();
      
      // Add scroll listener
      if (!scrollListenerAdded) {
        window.addEventListener('scroll', handleScroll, { passive: true });
        scrollListenerAdded = true;
      }
      
      // Apply animation class without transition (since it's already open)
      content.classList.add('mega-menu-new__content--animating');
      
      // Lazy load any images
      const lazyImages = content.querySelectorAll('.mega-menu-new__featured-product-image[data-src]');
      lazyImages.forEach(function(img) {
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
      });
    }
    
    // Helper function to animate close
    function animateClose(callback) {
      if (isClosing || !isOpen) return;
      
      isClosing = true;
      
      // Remove scroll listener when closing
      if (scrollListenerAdded) {
        window.removeEventListener('scroll', handleScroll);
        scrollListenerAdded = false;
      }
      
      // Check if user prefers reduced motion
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      
      if (prefersReducedMotion) {
        // Close instantly without animation
        container.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        isOpen = false;
        isClosing = false;
        if (callback) callback();
      } else {
        // Animate close
        content.classList.remove('mega-menu-new__content--animating');
        content.classList.add('mega-menu-new__content--closing');
        
        // Wait for animation to complete
        setTimeout(function() {
          content.classList.remove('mega-menu-new__content--closing');
          container.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          isOpen = false;
          isClosing = false;
          
          if (callback) callback();
        }, 200); // Match closing animation duration
      }
    }
    
    // Helper function to open menu
    function openMenu() {
      if (isOpen || isClosing) return;
      
      isOpen = true;
      container.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      
      // Set initial position
      updateMenuPosition();
      
      // Add scroll listener to update position as announcement bar appears/disappears
      if (!scrollListenerAdded) {
        window.addEventListener('scroll', handleScroll, { passive: true });
        scrollListenerAdded = true;
      }
      
      // Force animation to trigger consistently in Chrome
      // Remove any existing animation class first
      content.classList.remove('mega-menu-new__content--animating', 'mega-menu-new__content--closing');
      
      // Force reflow to ensure Chrome recognizes the class removal
      void content.offsetHeight;
      
      // Use requestAnimationFrame to add the animation class at the right time
      requestAnimationFrame(function() {
        content.classList.add('mega-menu-new__content--animating');
      });
      
      // Lazy load featured product images
      const lazyImages = content.querySelectorAll('.mega-menu-new__featured-product-image[data-src]');
      lazyImages.forEach(function(img) {
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
      });
      
      // Update sticky header nav state
      updateStickyHeaderNavState();
    }
    
    // Helper function to handle menu close completion
    function onMenuClosed() {
      // Menu is closing - reset all nav_links to initial state
      content.classList.remove('mega-menu-new__content--animating', 'mega-menu-new__content--closing');
      
      toggles.forEach(function(toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('mega-menu-new__main-toggle--active');
      });
      
      // Restore initial content (content blocks or placeholder)
      if (activeContent) {
        restoreInitialContent(activeContent);
      }
      
      // Reset tab order
      resetTabOrder(megaMenu);
      
      // Update sticky header nav state
      updateStickyHeaderNavState();
    }
    
    // Trigger button click handler
    if (trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (isOpen && !isClosing) {
          animateClose(onMenuClosed);
        } else if (!isOpen && !isClosing) {
          openMenu();
        }
      });
    }
    
    // Handle toggle buttons with open/close functionality
    toggles.forEach(function(toggle, index) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        const linkHandle = toggle.dataset.mainLink;
        const isCurrentlyActive = toggle.classList.contains('mega-menu-new__main-toggle--active');
        
        // If clicking the active toggle, close it and restore content blocks
        if (isCurrentlyActive) {
          // Deactivate this toggle
          toggle.setAttribute('aria-expanded', 'false');
          toggle.classList.remove('mega-menu-new__main-toggle--active');
          
          // Restore content blocks or placeholder
          restoreInitialContent(activeContent);
          
          // Reset tab order
          resetTabOrder(megaMenu);
          
          // Return focus to toggle button for keyboard users
          toggle.focus();
          return;
        }
        
        // Show content for the clicked toggle
        const targetContent = megaMenu.querySelector('[data-sub-content="' + linkHandle + '"]');
        if (targetContent && activeContent) {
          // Clear active content - hide content blocks when submenu is active
          activeContent.innerHTML = '';
          
          // Create a container for the sub-menu content only
          const subMenuContainer = document.createElement('div');
          subMenuContainer.className = 'mega-menu-new__sub-menu-container';
          
          // Copy featured products container if it exists (includes title and products)
          const sourceFeaturedContainer = targetContent.querySelector('.mega-menu-new__featured-products-container');
          if (sourceFeaturedContainer) {
            const featuredContainer = document.createElement('div');
            featuredContainer.className = 'mega-menu-new__featured-products-container';
            featuredContainer.innerHTML = sourceFeaturedContainer.innerHTML;
            
            // Add active class to the featured products grid inside
            const featuredGrid = featuredContainer.querySelector('.mega-menu-new__featured-products');
            if (featuredGrid) {
              featuredGrid.classList.add('mega-menu-new__featured-products--active');
            }
            
            subMenuContainer.appendChild(featuredContainer);
          }
          
          // Copy sub-links
          const sourceLinks = targetContent.querySelector('.mega-menu-new__sub-links');
          if (sourceLinks) {
            const linksContainer = document.createElement('div');
            linksContainer.className = 'mega-menu-new__sub-links mega-menu-new__sub-links--active';
            linksContainer.innerHTML = sourceLinks.innerHTML;
            subMenuContainer.appendChild(linksContainer);
          }
          
          activeContent.appendChild(subMenuContainer);
          
          // Update button state
          toggles.forEach(function(t) {
            t.setAttribute('aria-expanded', 'false');
            t.classList.remove('mega-menu-new__main-toggle--active');
          });
          toggle.setAttribute('aria-expanded', 'true');
          toggle.classList.add('mega-menu-new__main-toggle--active');
          
          // Update tab order to prioritize active content
          updateTabOrder(megaMenu, linkHandle);
          
          // Move focus to first interactive element in submenu for screen reader users
          setTimeout(function() {
            const firstLink = subMenuContainer.querySelector('a, button');
            if (firstLink) {
              firstLink.focus();
            }
          }, 50); // Small delay to ensure DOM is updated
        }
      });
    });
    
    // Handle focus leaving the mega menu
    megaMenu.addEventListener('focusout', function(event) {
      setTimeout(function() {
        const currentlyFocused = document.activeElement;
        if (isOpen && !megaMenu.contains(currentlyFocused) && !isClosing) {
          animateClose(onMenuClosed);
        }
      }, 10);
    });
    
    // Handle clicks outside to close (using capturing phase to avoid conflicts)
    document.addEventListener('click', function(event) {
      if (isOpen && !megaMenu.contains(event.target) && !isClosing) {
        animateClose(onMenuClosed);
      }
    }, true);
    
    // Handle escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && isOpen && !isClosing) {
        animateClose(function() {
          onMenuClosed();
          // Return focus to trigger button for keyboard users
          if (trigger) {
            trigger.focus();
          }
        });
      }
    });
  });
  
  // Helper function to manage sticky header nav state
  function updateStickyHeaderNavState() {
    const stickyHeader = document.querySelector('sticky-header');
    const anyMegaMenuOpen = document.querySelector('header-menu-new .mega-menu-new.is-open');
    
    if (stickyHeader) {
      if (anyMegaMenuOpen) {
        stickyHeader.classList.add('nav-element-open');
      } else {
        stickyHeader.classList.remove('nav-element-open');
      }
    }
  }
  
  // Helper function to update tab order
  function updateTabOrder(megaMenu, activeMainLinkHandle) {
    // Reset all tab indices first
    resetTabOrder(megaMenu);
    
    if (!activeMainLinkHandle) {
      return;
    }
    
    const orderedElements = [];
    
    // Get all main columns in their visual order
    const mainColumns = megaMenu.querySelectorAll('.mega-menu-new__main-column');
    let activeToggleIndex = -1;
    
    // Find the index of the active toggle
    mainColumns.forEach(function(column, index) {
      const toggle = column.querySelector('.mega-menu-new__main-toggle');
      if (toggle && toggle.dataset.mainLink === activeMainLinkHandle) {
        activeToggleIndex = index;
      }
    });
    
    // Build tab order: maintain visual sequence but insert submenu content after active toggle
    mainColumns.forEach(function(column, index) {
      const toggle = column.querySelector('.mega-menu-new__main-toggle');
      const link = column.querySelector('.mega-menu-new__main-link');
      
      // Add the main item (toggle or link)
      if (toggle) {
        orderedElements.push(toggle);
      } else if (link) {
        orderedElements.push(link);
      }
      
      // If this is the active toggle, add its submenu content immediately after
      if (index === activeToggleIndex) {
        // First add featured products if they exist
        const activeFeaturedProducts = megaMenu.querySelector('.mega-menu-new__featured-products--active');
        if (activeFeaturedProducts) {
          const featuredLinks = activeFeaturedProducts.querySelectorAll('a');
          featuredLinks.forEach(function(featuredLink) {
            orderedElements.push(featuredLink);
          });
        }
        
        // Then add submenu links
        const activeSubmenuContent = megaMenu.querySelector('.mega-menu-new__sub-links--active');
        if (activeSubmenuContent) {
          const submenuLinks = activeSubmenuContent.querySelectorAll('a');
          submenuLinks.forEach(function(submenuLink) {
            orderedElements.push(submenuLink);
          });
        }
      }
    });
    
    // Set tab indices to maintain this order
    orderedElements.forEach(function(element, index) {
      element.tabIndex = index + 1; // Start from 1 to keep within mega menu
    });
  }
  
  // Helper function to reset tab order
  function resetTabOrder(megaMenu) {
    const allFocusable = megaMenu.querySelectorAll('button, a');
    allFocusable.forEach(function(element) {
      element.tabIndex = 0;
    });
  }
  
  // Helper function to restore initial content (content blocks or placeholder)
  function restoreInitialContent(activeContent) {
    if (!activeContent) return;
    
    // Clear current content
    activeContent.innerHTML = '';
    
    // Restore original content from cached HTML
    if (activeContent.dataset.originalContent) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = activeContent.dataset.originalContent;
      activeContent.appendChild(tempDiv.firstChild);
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
